import { jsx as _jsx } from "react/jsx-runtime";
import { PrimitiveErrorBoundary } from '../lib/error-boundary.js';
import { DiagramPrimitive, DiagramPropsSchema } from './diagram.js';
import { SIMPLE_PRIMITIVES } from './simple-registry.js';
import { UnsupportedVisualizationPrimitive, UnsupportedVisualizationPropsSchema, } from './unsupported-visualization.js';
/**
 * All 13 presentation primitives, keyed by `Block['type']`. The shared
 * render layer for both the M1 digest ({@link DigestView}) and the M2
 * generative json-render catalog ({@link almanacCatalog}).
 */
export const PRIMITIVES = {
    ...SIMPLE_PRIMITIVES,
    diagram: {
        propsSchema: DiagramPropsSchema,
        description: 'A mermaid diagram request. Not rendered as a real diagram in v1 — always pair it with a fallback_block that conveys the same information as a simple block.',
        Component: DiagramPrimitive,
    },
    unsupported_visualization_request: {
        propsSchema: UnsupportedVisualizationPropsSchema,
        description: 'Use when asked for a visualization this catalog cannot render. Explain why in `reason` and provide an equivalent fallback_block.',
        Component: UnsupportedVisualizationPrimitive,
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
};
/**
 * Render any block (all 13 types) through the shared primitive registry.
 * This is the M1 full-fidelity render path — it does not go through
 * json-render's spec format at all.
 */
export function renderBlock(block, overlay, searchAnchorPrefix, highlightedAnchor, onFeedback, pendingFeedback) {
    const entry = PRIMITIVES[block.type];
    const { type: _type, ...props } = block;
    const Component = entry.Component;
    return (_jsx(PrimitiveErrorBoundary, { label: block.type, children: _jsx(Component, { ...props, overlay: overlay, searchAnchorPrefix: searchAnchorPrefix, highlightedAnchor: highlightedAnchor, onFeedback: onFeedback, pendingFeedback: pendingFeedback }) }));
}
